import React, { useState } from 'react';
import { validateScanUrl } from '@privisy/ui-bridge';
import { useStartLiteScan } from '../../hooks/useStartLiteScan';
import type { TeaserCtaSlot } from './ReportTeaser';

export const FREE_AUDIT_CTA_LABEL = 'Get your free audit';
const FALLBACK_SCAN_URL = 'https://www.getprivisy.com/?referrer=report_summary';

/**
 * The teaser's CTA for a viewer who does not own the report (#1807): it runs
 * the anonymous full audit (`POST /api/anonymous-audit`) of the report's URL,
 * so a forwarded or outreach link turns into the viewer's own locked audit.
 * A stored URL that no longer validates falls back to the marketing site's
 * form. Both slots share one scan start; an error shows under the one pressed.
 */
export function useFreeAuditCta(url: string): (where: TeaserCtaSlot) => React.ReactNode {
  const { start, isStarting, error } = useStartLiteScan('full');
  const [pressed, setPressed] = useState<TeaserCtaSlot | null>(null);
  const target = validateScanUrl(url);

  return function renderFreeAuditCta(where) {
    return (
      <>
        {target.ok ? (
          <button
            type="button"
            className="sales-cta"
            disabled={isStarting}
            onClick={() => {
              setPressed(where);
              void start(target.normalized);
            }}
          >
            {isStarting && pressed === where ? 'Starting scan…' : FREE_AUDIT_CTA_LABEL}
          </button>
        ) : (
          <a className="sales-cta" href={FALLBACK_SCAN_URL} target="_blank" rel="noopener noreferrer">{FREE_AUDIT_CTA_LABEL}</a>
        )}
        {error && pressed === where ? <p role="alert" className="sales-error">{error}</p> : null}
      </>
    );
  };
}
